/**
 * POS Auth Context
 *
 * Handles PIN-based authentication for POS terminals.
 * Passes restaurant_slug from device registration so the API
 * scopes the PIN lookup to the correct merchant.
 */

import React, { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const AuthContext = createContext(null);

// Module scope: one identity for every render, so consumers can list it as a dependency.
const getToken = () => localStorage.getItem('pos_token');

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('pos_token');
    const savedUser = localStorage.getItem('pos_user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const logout = () => {
    localStorage.removeItem('pos_token');
    localStorage.removeItem('pos_user');
    setUser(null);
  };


  return (
    <AuthContext.Provider value={{ user, loading, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
